export default "__VITE_ASSET__BiwXzvQJ__"